import { render } from "./LiveDemoUrlDialog.vue?vue&type=template&id=5bfe9f3f"
import script from "./LiveDemoUrlDialog.vue?vue&type=script&lang=js"
export * from "./LiveDemoUrlDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__